const NTFY_CZ_ID = 17
const NTFY_DE_ID = 15
const NTFY_ID = 11
const NTFY_SYMBOL = 'NTFY'
const NTFY_DE_SYMBOL = 'NTFY_DE'
const NTFY_CZ_SYMBOL = 'NTFY_CZ'
const EXPRESS_DE_SYMBOL = 'EX_D'
const EXPRESS_SYMBOL = 'EX'
const VAT_EX = 'VAT_EX'
const WORK_TAG_EXPRESS_ID = 669
const DELIVERY_TYPES = [
  {
    id: 'production_date',
    value: Translator.trans('overproduction.production_date'),
  },
  {
    id: 'delivery_date',
    value: Translator.trans('overproduction.delivery_date'),
  }
]
const material = {
  TYPE_PORTION: 'portion',
  TYPE_PACKAGE: 'package',
  UNIT_MASS: 'mass',
  UNIT_PIECE: 'piece',
}

const ROUTE_DEFAULT_COUNTRY = 'PL'
const DRIVERS_REPORT_DEFAULT_COUNTRY = 'PL'
const tag = {
  routeCountry: {
    GERMANY: 'DE',
  }
}

const MEMBER_GET_MEMBER_CODE_TYPES = [
  {
    id: 'promo_code',
    value: Translator.trans('member_get_member.promoCode'),
  },
  {
    id: 'member_get_member',
    value: Translator.trans('member_get_member.member_get_member'),
  }
]

const PRODUCT_CATEGORIES_FRESH = 'FRESH'
const PRODUCT_CATEGORIES_BREAD = 'BREAD'
const PRODUCT_CATEGORIES_OTHER = 'OTHER'
const PRODUCT_CATEGORIES_ALL = 'ALL'

const COPY_SELECT_FROM_BRAND_MAP = {
  [NTFY_SYMBOL]: [
    NTFY_SYMBOL,
  ],
  [NTFY_DE_SYMBOL]: [
    NTFY_SYMBOL,
    NTFY_DE_SYMBOL,
  ],
}

const TEAM_TYPES = {
  PRODUCTION: 'PRODUCTION',
  UNFOLDING: 'UNFOLDING',
}

export {
  NTFY_CZ_ID,
  NTFY_DE_ID,
  NTFY_ID,
  NTFY_SYMBOL,
  NTFY_DE_SYMBOL,
  NTFY_CZ_SYMBOL,
  EXPRESS_DE_SYMBOL,
  EXPRESS_SYMBOL,
  VAT_EX,
  WORK_TAG_EXPRESS_ID,
  DELIVERY_TYPES,
  material,
  ROUTE_DEFAULT_COUNTRY,
  DRIVERS_REPORT_DEFAULT_COUNTRY,
  tag,
  MEMBER_GET_MEMBER_CODE_TYPES,
  PRODUCT_CATEGORIES_FRESH,
  PRODUCT_CATEGORIES_BREAD,
  PRODUCT_CATEGORIES_OTHER,
  PRODUCT_CATEGORIES_ALL,
  COPY_SELECT_FROM_BRAND_MAP,
  TEAM_TYPES
}
